var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m4.38894 1.27832c.1841 0 .33334.14924.33334.33333v.77778h6.55552v-.77778c0-.18409.1493-.33333.3334-.33333s.3333.14924.3333.33333v.77778h1.8889c.4909 0 .8889.39797.8889.88889v10.55558c0 .4909-.398.8889-.8889.8889h-11.66668c-.49092 0-.88889-.398-.88889-.8889v-10.55558c0-.49092.39797-.88889.88889-.88889h1.88889v-.77778c0-.18409.14924-.33333.33333-.33333zm-.33333 1.77778h-1.88889c-.12273 0-.22222.09949-.22222.22222v1.88889h12.1111v-1.88889c0-.12273-.0995-.22222-.2222-.22222h-1.8889v1.33333c0 .1841-.1492.33333-.3333.33333s-.3334-.14923-.3334-.33333v-1.33333h-6.55552v1.33333c0 .1841-.14924.33333-.33334.33333-.18409 0-.33333-.14923-.33333-.33333zm9.99999 2.77778h-12.1111v8.00002c0 .1227.09949.2222.22222.2222h11.66668c.1227 0 .2222-.0995.2222-.2222z",
    fill: "#364152",
    fillOpacity: 0.5,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarLight);
export default __webpack_public_path__ + "static/media/calendar-light.888e6a63e30d3abaaf84acb2a4ce6553.svg";
export { ForwardRef as ReactComponent };